import { HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { KeycloakService } from './keycloak.service';

export const keycloakHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const keyclokService = inject(KeycloakService);
  const token = keyclokService.Keycloak.token;
  if(token) { 
    const authRequest = req.clone({
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`
      })
    })
    return next(authRequest);
  }
  return next(req);
};
